import type Configurations from '@/modules/common/common/models/APP/Configuration'
import { UserRoleEnum } from '../models/enums'
import type { MinMaxAge } from '@/modules/common/common/models/APP/MinMaxAge'

export function hiringAges(hiringMaxAges: Record<string, MinMaxAge>, role: UserRoleEnum) {
  if (!hiringMaxAges) {
    return undefined
  }

  if (role === UserRoleEnum.HOLDER_INSURED && hiringMaxAges.holderInsured) {
    return hiringMaxAges.holderInsured
  }

  if (role === UserRoleEnum.HOLDER_NOT_INSURED && hiringMaxAges.holderNotInsured) {
    return hiringMaxAges.holderNotInsured
  }

  if (role === UserRoleEnum.INSURED && hiringMaxAges.insured) {
    return hiringMaxAges.insured
  }

  return undefined
}

export function hiringMinAge(
  extra: Record<string, any> | undefined,
  currentHiringAge: MinMaxAge | undefined,
  config: Record<string, any>,
  defaultMinAge = 0
): number {
  if (extra?.minAge) return extra.minAge
  if (currentHiringAge) return currentHiringAge.min
  if (config?.minAge) return config.minAge
  return defaultMinAge
}

export function hiringMaxAge(
  extra: Record<string, any> | undefined,
  currentHiringAge: MinMaxAge | undefined,
  config: Record<string, any>,
  defaultMaxAge = 115
): number {
  if (extra?.maxAge) return extra.maxAge
  if (currentHiringAge) return currentHiringAge.max
  if (config?.maxAge) return config.maxAge
  return defaultMaxAge
}

export function getRoleMinMaxAge(
  configurations: Configurations,
  role: string
): { min: string | null; max: string | null } {
  try {
    const ages = configurations!.hiringMaxAges

    if (role === UserRoleEnum.HOLDER_INSURED) {
      return ages?.holderInsured
    }

    if (role === UserRoleEnum.HOLDER_NOT_INSURED) {
      return ages?.holderNotInsured
    }

    return ages?.insured
  } catch (error) {
    console.log(error)
    return { min: null, max: null }
  }
}
